import { BuchLebenChristiOffen, BetbuchOffen, Jagdtasche } from "../../Utils/GlbLoaderArtefakte.jsx";
import ExperienceModelViewer from "../ExperienceModelViewer.jsx";

export default function ArtefaktBundlesMuseumStadtBadIschl({ currentMuseumId }) {
  const { buchLebenChristiOffen } = BuchLebenChristiOffen();
  const { betbuchOffen } = BetbuchOffen();
  const { jagdtasche } = Jagdtasche();

  const artefactArray = [buchLebenChristiOffen, betbuchOffen, jagdtasche];

  return <ExperienceModelViewer modelArray={artefactArray} currentMuseumId={currentMuseumId} />;
}
